// extracted by mini-css-extract-plugin
module.exports = {"c16bqd94":"c16bqd94"};